import React from 'react'

type Props = {
  isThinking: boolean
  compact?: boolean
  className?: string
}

const AiThinkingIndicator: React.FC<Props> = ({isThinking, compact = false, className = ''}) => {
  if (!isThinking) return null

  return (
    <div className={`ai-thinking-indicator ${compact ? 'compact' : ''} ${className}`.trim()}>
      <div className='ai-thinking-glow' aria-hidden='true' />
      <div className='ai-thinking-ring' aria-hidden='true' />
    </div>
  )
}

export default React.memo(AiThinkingIndicator)
